import { Survey, SurveyReport, SurveySegment, SurveyTopic, DefaultScoreValueMapping, ThemeSurveyTopic, IndicatorSurveyTopic, QuestionSurveyTopic } from "../../DTOs";
import { surveyQuestionHelper } from "../../helpers/surveyQuestionHelper";
import { SurveyReportBuilder } from "./SurveyReportBuilder";

export const surveyTopicModule = {
    getSurveyTopics
};

function getSurveyTopics(survey:Survey, surveyReport:SurveyReport, segmentFilter:SurveySegment[][]):SurveyTopic[] 
{
    const reportBuilder = new SurveyReportBuilder(survey, surveyReport);
    const report = reportBuilder.getData(segmentFilter);
    
    const topics:SurveyTopic[] = [];

    topics.push(...report.themeData.map(d =>
        {
            const themeIndex = survey.themes.findIndex(t => t.name === d.theme.name);
            const topic:ThemeSurveyTopic = 
            {
                linkType: 'theme', 
                themeIndex,
                questionsInTheme:survey.themes[themeIndex].questions.length,
                data:{
                    title: d.theme.name,
                    selections: d.stats.data,
                    scoreMap: DefaultScoreValueMapping
                }
            };
            return topic;
        }
    ));
    

    const indicatorReport = report.indicatorData;
    topics.push(...indicatorReport.map(d => 
        {
            const questionsWithIndicator = d.questions.map(qd => qd.question).length;
            const topic:IndicatorSurveyTopic = 
            {
                linkType: 'indicator', 
                indicator: d.indicator,
                questionsWithIndicator,
                data:{
                    title: d.indicator,
                    selections: d.stats.data,
                    scoreMap: DefaultScoreValueMapping
                }
            };
            return topic;
        }
    ));
    
    topics.push(...report.themeData.flatMap((d, themeIndex) => 
        d.questions.map((q, questionIndex) =>
        {

            const topic:QuestionSurveyTopic = 
            {
                linkType: 'question', 
                themeIndex, 
                questionIndex,
                question: q.question,
                data:{
                    title: q.question.title,
                    selections: q.stats.data,
                    scoreMap: surveyQuestionHelper.isScoredQuestion(q.question) 
                        ? surveyQuestionHelper.getScoreMapping(q.question)
                        : null
                }
            };
            return topic;
        })
    ));

    return topics;
}